<!-- Customers List Page with Splitter Layout -->
<div class="customers-list-page mt-2">
  <!-- Main Content Layout with Flex -->
  @if (!initialLoading()) {
    <div class="main-layout">
      <!-- Sidebar Toggle (always visible) -->
      <div class="sidebar-toggle-area">
        <p-button
          [icon]="sidebarCollapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'"
          [text]="true"
          size="small"
          (onClick)="toggleSidebar()"
          [pTooltip]="
            sidebarCollapsed() ? 'Expand filters' : 'Collapse filters'
          "
          tooltipPosition="right"
          class="sidebar-toggle-btn"
        />

        <!-- Collapsed State with Filter Button -->
        @if (sidebarCollapsed()) {
          <div class="collapsed-controls">
            <button
              class="collapsed-filter-btn"
              (click)="toggleSidebar()"
              [pTooltip]="'Filters'"
              tooltipPosition="right"
            >
              <i class="pi pi-filter"></i>
              @if (hasActiveFilters()) {
                <div class="filter-dot-indicator">
                  <i class="pi pi-circle-fill"></i>
                </div>
              }
            </button>
            <!-- Clear All Button for Collapsed State -->
            @if (hasActiveFilters()) {
              <button
                class="collapsed-clear-btn"
                (click)="onClearFilters(); $event.stopPropagation()"
                [pTooltip]="'Clear All Filters'"
                tooltipPosition="right"
              >
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
        }
      </div>

      <!-- Mobile Backdrop (click to close filter sidebar) -->
      <div
        class="mobile-backdrop"
        [class.visible]="!sidebarCollapsed()"
        (click)="toggleSidebar()"
      ></div>

      <!-- Filter Sidebar -->
      <div class="filter-sidebar" [class.collapsed]="sidebarCollapsed()">
        <!-- Filter Content -->
        <div class="sidebar-content">
          <app-customers-filters
            [filterForm]="filterForm"
            [loading]="loading()"
            [drawerMode]="true"
            [skipLocalStorageLoad]="skipLocalStorageLoad()"
            (filtersChanged)="onFiltersChanged($event)"
            (clearFilters)="onClearFilters()"
          />
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="content-area" [class.sidebar-open]="!sidebarCollapsed()">
        <!-- Compact Toolbar -->
        <div
          class="content-toolbar surface-section border-bottom-1 surface-border"
        >
          <div
            class="flex align-items-center justify-content-between p-2 justify-between"
          >
            <div class="flex align-items-center items-center gap-3">
              <span class="text-sm text-600">
                {{ data()?.pagination?.totalItems || 0 }}
                {{
                  data()?.pagination?.totalItems === 1
                    ? "Customer"
                    : "Customers"
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- Table Container -->
        <div class="table-container flex-1 overflow-hidden">
          <app-customers-table
            [data]="data()"
            [loading]="loading()"
            scrollHeight="flex"
            (sortChanged)="onSortChanged($event)"
            (pageChanged)="onPageChanged($event)"
            (rowAction)="onRowAction($event)"
          />
        </div>
      </div>
    </div>
  }

  <!-- Initial Loading Skeleton -->
  @if (initialLoading()) {
    <app-list-page-skeleton
      [sidebarCollapsed]="sidebarCollapsed()"
      filterPreset="customers"
      tablePreset="customers"
    />
  }

  <!-- Empty State (when no site selected) -->
  @if (!currentSiteId()) {
    <div class="empty-state-container">
      <div
        class="flex flex-column align-items-center justify-content-center h-20rem gap-4"
      >
        <i class="pi pi-exclamation-circle text-6xl text-400"></i>
        <h2 class="text-xl font-medium text-600 m-0">No Site Selected</h2>
        <p class="text-center text-500 max-w-30rem">
          Please select a site from the navigation to view customers.
        </p>
      </div>
    </div>
  }
</div>

<!-- Toast Messages -->
<p-toast
  position="top-right"
  [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
/>

<!-- Confirmation Dialog -->
<p-confirmDialog
  [style]="{ width: '450px' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
/>
